/**
 * Türkiye sivil plaka biçimi: İL (01–81) + HARF (1–3) + RAKAM.
 *   1 harf  → 4 veya 5 rakam   (34 A 1234, 34 A 12345)
 *   2 harf  → 3 veya 4 rakam   (34 AB 123, 34 AB 1234)
 *   3 harf  → 2 veya 3 rakam   (34 ABC 12, 34 ABC 123)
 * Türkçe'ye özgü harfler (Ç, Ğ, İ, Ö, Ş, Ü) ile Q, W, X plakalarda kullanılmaz.
 * Resmî/özel seri plakalar (diplomatik, geçici, askeri...) bu denetimin kapsamı dışındadır;
 * çağıran taraf bunlar için doğrulamayı atlayabilmelidir.
 */
const PLATE_PATTERN = /^(0[1-9]|[1-7]\d|8[01])([A-PR-VYZ]{1})(\d{4,5})$|^(0[1-9]|[1-7]\d|8[01])([A-PR-VYZ]{2})(\d{3,4})$|^(0[1-9]|[1-7]\d|8[01])([A-PR-VYZ]{3})(\d{2,3})$/;
/** Boşluk/tire atar, büyük harfe çevirir. Türkçe yerel ayarı KULLANILMAZ ("i" → "I" olmalı, "İ" değil). */
export function normalizePlate(value) {
    return value.replace(/[\s-]+/g, "").toLocaleUpperCase("en-US");
}
export function isValidTrPlate(value) {
    return PLATE_PATTERN.test(normalizePlate(value));
}
/** "34ABC123" → "34 ABC 123". Geçersiz plakada normalleştirilmiş hâli döner. */
export function formatPlate(value) {
    const plate = normalizePlate(value);
    const match = PLATE_PATTERN.exec(plate);
    if (!match)
        return plate;
    const groups = match.slice(1).filter((group) => group !== undefined);
    return groups.join(" ");
}
//# sourceMappingURL=plate.js.map